import { useSelector, useDispatch } from 'react-redux';
import { pushUserSettingsModal } from '../../Modals/redux/actionCreators';
import { getContentFilter, isUserOlderThan18 } from '../../publicSession/selectors';
/** Returns selectors and a dispatched pushModal action related to content_filter:
 *  the setting that controls what level of mature content the user wants to see */ export function useContentFilter() {
    const contentFilter = useSelector(getContentFilter);
    const isOver18 = useSelector(isUserOlderThan18);
    const dispatch = useDispatch();
    return {
        contentFilter,
        isUserOlderThan18: isOver18,
        pushUserSettingsModal: ()=>dispatch(pushUserSettingsModal())
    };
}
